(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["armadio-irl"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('armadio-irl')) {
    customElements.define('armadio-irl', class ArmadioIrl extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('[data-irl-rail]');
        this.cards = Array.from(this.querySelectorAll('[data-irl-card]'));
        this.videos = Array.from(this.querySelectorAll('video'));
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.previousButton = this.querySelector('[data-irl-previous]');
        this.nextButton = this.querySelector('[data-irl-next]');

        this.onVisibilityChange = this.onVisibilityChange.bind(this);
        this.updateNavigation = this.updateNavigation.bind(this);

        this.setupVideos();
        this.setupNavigation();
        document.addEventListener('visibilitychange', this.onVisibilityChange);
      }

      disconnectedCallback() {
        this.videoObserver?.disconnect();
        this.railObserver?.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
      }

      setupVideos() {
        this.videoObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            const visible = entry.isIntersecting && entry.intersectionRatio >= 0.55;

            if (visible && !this.reduceMotion.matches && video.dataset.userPaused !== 'true' && !document.hidden) {
              video.play().catch(() => this.updateVideoControls(video));
            } else {
              video.pause();
            }

            this.updateVideoControls(video);
          });
        }, { threshold: [0, 0.55, 1] });

        this.videos.forEach((video) => {
          const card = video.closest('[data-irl-card]');
          const playButton = card.querySelector('[data-irl-play]');
          const muteButton = card.querySelector('[data-irl-mute]');

          video.muted = true;
          video.loop = true;
          video.playsInline = true;
          this.videoObserver.observe(video);

          playButton?.addEventListener('click', () => {
            if (video.paused) {
              video.dataset.userPaused = 'false';
              video.play().catch(() => this.updateVideoControls(video));
            } else {
              video.dataset.userPaused = 'true';
              video.pause();
            }
            this.updateVideoControls(video);
          });

          muteButton?.addEventListener('click', () => {
            const willUnmute = video.muted;
            this.videos.forEach((otherVideo) => {
              otherVideo.muted = true;
              this.updateVideoControls(otherVideo);
            });
            video.muted = !willUnmute;
            this.updateVideoControls(video);
          });

          video.addEventListener('play', () => this.updateVideoControls(video));
          video.addEventListener('pause', () => this.updateVideoControls(video));
          video.addEventListener('volumechange', () => this.updateVideoControls(video));
        });
      }

      updateVideoControls(video) {
        const card = video.closest('[data-irl-card]');
        const playButton = card?.querySelector('[data-irl-play]');
        const muteButton = card?.querySelector('[data-irl-mute]');
        const isPlaying = !video.paused;
        const isMuted = video.muted;

        if (playButton) {
          playButton.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
          playButton.setAttribute('aria-pressed', String(isPlaying));
          playButton.querySelector('[data-icon-play]').hidden = isPlaying;
          playButton.querySelector('[data-icon-pause]').hidden = !isPlaying;
        }

        if (muteButton) {
          muteButton.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');
          muteButton.setAttribute('aria-pressed', String(isMuted));
          muteButton.querySelector('[data-icon-muted]').hidden = !isMuted;
          muteButton.querySelector('[data-icon-sound]').hidden = isMuted;
        }
      }

      setupNavigation() {
        if (!this.rail || this.cards.length < 2) return;

        this.previousButton?.addEventListener('click', () => this.scrollByCard(-1));
        this.nextButton?.addEventListener('click', () => this.scrollByCard(1));
        this.rail.addEventListener('scroll', this.updateNavigation, { passive: true });
        this.railObserver = new ResizeObserver(this.updateNavigation);
        this.railObserver.observe(this.rail);
        this.updateNavigation();
      }

      scrollByCard(direction) {
        const firstCard = this.cards[0];
        if (!firstCard) return;
        const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
        this.rail.scrollBy({ left: direction * (firstCard.getBoundingClientRect().width + gap), behavior: this.reduceMotion.matches ? 'auto' : 'smooth' });
      }

      updateNavigation() {
        if (!this.rail) return;
        const maxScroll = this.rail.scrollWidth - this.rail.clientWidth;
        if (this.previousButton) this.previousButton.disabled = this.rail.scrollLeft <= 2;
        if (this.nextButton) this.nextButton.disabled = this.rail.scrollLeft >= maxScroll - 2;
      }

      onVisibilityChange() {
        if (document.hidden) {
          this.videos.forEach((video) => video.pause());
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
